// Куда ведёт «назад» из карточки устройства (/intercom/:device, /gate/:gate),
// business_apps#1465.

// PUSH / REPLACE — карточку открыли переходом внутри Контроля: перед ней
// в истории вкладки наша страница, возвращаемся history.goBack().
// POP — первый экран вкладки (ссылка из мессенджера или другого кабинета,
// закладка), перезагрузка или «назад/вперёд» браузера: что лежит в истории
// перед карточкой, неизвестно, и goBack() может увести из Контроля.
// history.length тут не помогает: он всегда ≥ 1 и считает и чужие сайты.
export const isInAppNavigation = (action) =>
  action === 'PUSH' || action === 'REPLACE'

// Страница адреса, где стоит устройство. У калитки своей страницы адреса нет
// (/gate/:uuid — это её же карточка), у неустановленного устройства нет
// адреса — в обоих случаях ведём на главную.
export const deviceAddressPath = (device) => {
  const { address_type: addressType, address_uuid: addressUuid } = device || {}
  if (!addressUuid || addressType === 'gate') return '/'
  if (addressType === 'house') return `/h/${addressUuid}`
  return `/e/${addressUuid}`
}
